export const CHECKOUT_STATUS = {
    INITIATED: 'INITIATED',
    COMPLETED: 'COMPLETED'
}

export const TRANSLATION_FILE_NAME = {
    LABEL: 'UILabels.CSV',
    MESSAGE: 'UIMessages.CSV'
}

export const TRANSLATION_TYPE = {
    LABEL: "LABEL",
    MESSAGE: "MESSAGE"
}

export const USER_PAYMENT_METHOD_PREFERENCE = {
    CARD: 'CARD',
    APPLE_PAY: 'APPLE_PAY',
    GOOGLE_PAY: 'GOOGLE_PAY',
    PAYPAL: 'PAYPAL'
}

// ISO 3166-1 alpha-2 code for the United Kingdom. We are not permitted to sell to UK addresses.
export const UNITED_KINGDOM_COUNTRY_CODE = 'GB'

// Our office street address. Existing users whose billing address is the office address are
// redirected to re-enter a real billing address.
export const OFFICE_STREET_ADDRESS = '20472 Chartwell Center Dr'

// Placeholder account name. Existing users whose billing name is "Investor Success" are
// redirected to re-enter real billing details.
export const INVESTOR_SUCCESS_NAME = 'Investor Success'

// Currencies that PayPal is offered for. Add more here (e.g. 'GBP') to expand the supported regions.
// Default fallback used only when the /site config doesn't provide a currency list.
export const PAYPAL_ENABLED_CURRENCIES = ['EUR'];

// Prefer the server-provided (Key Vault) PayPal currency list so support for a new currency can be
// enabled via config without a frontend build; fall back to the built-in default when it's absent.
export const resolvePayPalCurrencies = (configured) =>
    Array.isArray(configured) && configured.length > 0 ? configured : PAYPAL_ENABLED_CURRENCIES;
